// The proctoring store is registered on the root store, so anything it imports statically
// lands in the entry bundle -- TensorFlow, face-api and livekit used to ship to the login
// page, admin dashboards and evaluators, none of which run a detector. These loaders pull
// each library in the first time an action actually needs it.
//
// A failed load (a chunk fetch dropped on a flaky connection) is not cached, so the next
// call retries instead of every later caller inheriting the same rejection.
function lazyModule(load) {
  let promise = null;
  return () => {
    if (!promise) {
      promise = load().catch((err) => {
        promise = null;
        throw err;
      });
    }
    return promise;
  };
}

export const loadFaceApi = lazyModule(() =>
  import(/* webpackChunkName: "face-api" */ "@vladmandic/face-api")
);

export const loadLivekit = lazyModule(() =>
  import(/* webpackChunkName: "livekit" */ "livekit-client")
);

// One module rather than four import() calls, so tfjs and its backends still evaluate in
// the order cameraProctoring.js used to import them.
export const loadTfjsRuntime = lazyModule(() =>
  import(
    /* webpackChunkName: "tfjs-runtime" */ "@/store/proctoring/tfjsRuntime"
  )
);
